import { observable } from "mobx";

class DimensionsStore {
  @observable
  private _width: number = 0;
  @observable
  private _height: number = 0;

  constructor() {
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
    this.updateWindowDimensions();
  }

  private updateWindowDimensions() {
    this._width = window.innerWidth;
    this._height = window.innerHeight;
  }

  public get width() {
    return this._width;
  }

  public get height() {
    return this._height;
  }
}

const dimensionsStore = new DimensionsStore();
export default dimensionsStore;
